module.exports = __webpack_public_path__ + "img/img-infp.7e00f468.jpg";